/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MaterialUrl = {
    position: number;
    url: string;
    name: string;
    /**
     * Type of URL: excel (Google Sheets), doc (Google Docs), flowchart (Miro or similar), pdf, or default
     */
    url_type?: MaterialUrl.url_type;
};
export namespace MaterialUrl {
    /**
     * Type of URL: excel (Google Sheets), doc (Google Docs), flowchart (Miro or similar), pdf, or default
     */
    export enum url_type {
        EXCEL = 'excel',
        DOC = 'doc',
        FLOWCHART = 'flowchart',
        PDF = 'pdf',
        DEFAULT = 'default',
    }
}

